import React from 'react';

export default function TextBlockLoader() {
  return (
    <div className="loader-container">
      <div className="skeleton" style={{ height: '300px', width: '100%' }}></div> {/* Large box for instructions */}
    </div>
  );
}